<template>
    <transition name="modal-fade">
        <div
            v-show="show"
            class="modal"
            @keyup.esc="onEsc"
            tabindex="-1"
        >
            <div class="modal__backdrop" @click="onClickMask" />

            <div class="modal__body" :class="{ 'modal__body--transparent': transparent }">
                <div class="modal__body__center"><span v-if="closeBtn" class="modal__body__center__close" @click="$emit('close')">{{$t('close_x') }}</span></div>
                <slot></slot>
            </div>
        </div>
    </transition>
</template>

<script lang="ts">
    import { defineComponent } from 'vue'

    export default defineComponent({
        props: {
            closeBtn: {
                type: Boolean,
                required: false,
                default: true
            },
            show: {
                type: Boolean,
                required: true,
            },
            transparent: {
                type: Boolean,
                required: false
            }
        },
        setup(props, { emit }) {
            const close = () => emit('close')
            const onEsc = () => emit('close')
            const onClickMask = () => emit('close')

            return {
                close,
                onEsc,
                onClickMask
            }
        }
    })
</script>
